import global from '../global'

const opusList = global.serverUrl + '/backstage/opus/list'
const opusGet = global.serverUrl + '/backstage/opus/get'
const opusSave = global.serverUrl + '/backstage/opus/save'
export default {
  opusList,
  opusGet,
  opusSave
}



// WEBPACK FOOTER //
// ./src/config/api/opus.js